import { destination, type DestinationId } from "@/lib/destinations";

/**
 * A stub for a destination the rail shows but this pass does not build.
 *
 * The rail deliberately lists all six from the start: the IA is fixed, and a destination that
 * appears later would change the muscle memory of every slot beneath it.
 */
export function NotBuiltYet({ id, plannedIn }: { id: DestinationId; plannedIn: string }) {
  const d = destination(id);
  return (
    <div className="flex flex-1 items-center justify-center p-10">
      <div className="max-w-[420px] text-center">
        <div aria-hidden className="font-jp text-[46px]/[1] text-ink-off">
          {d.word}
        </div>
        <h2 className="mt-4 text-title font-semibold text-ink">{d.label}</h2>
        <p className="mt-2 text-secondary text-ink-3">Not built yet — {plannedIn}.</p>
      </div>
    </div>
  );
}
